import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const AdminPanelHeaderInfo = ({
  loading,
  itemsVisible,
  itemsTotal,
  itemTitle,
}) => {
  const intl = useIntl();

  return (
    <div className="header-actions">
      {!loading && (
        <div className="items-displaying">
          <span>
            {intl.formatMessage(
              { defaultMessage: '{itemsVisible} of {itemsTotal} {itemTitle}{itemsTotal, plural, one {} other {s}}' },
              { itemsVisible, itemsTotal, itemTitle },
            )}
          </span>
        </div>
      )}
    </div>
  );
};

AdminPanelHeaderInfo.propTypes = {
  loading: PropTypes.bool.isRequired,
  itemsVisible: PropTypes.string.isRequired,
  itemsTotal: PropTypes.number.isRequired,
  itemTitle: PropTypes.string.isRequired,
};

export default AdminPanelHeaderInfo;
